/**
 * Auth redirect helpers for the Axios interceptor.
 * Public marketing pages must not hard-redirect to /login on expected 401s.
 */

/** Marketing / auth pages where a 401 must not force a hard redirect to login. */
export const isPublicAuthPath = (pathname: string): boolean => {
  // App / admin paths must always redirect on 401 — never treat as public marketing.
  if (pathname.startsWith('/backoffice')) return false;

  return (
    pathname === '/' ||
    pathname === '/login' ||
    pathname === '/privacy' ||
    pathname === '/terms'
  );
};

/** Unauthenticated API routes (e.g. landing contact) — 401 must not hard-redirect. */
export const isPublicApiPath = (url?: string): boolean =>
  Boolean(url?.includes('/api/public/'));

/** Session probe used by AuthContext — 401 means "logged out", not "kick to login". */
export const isAuthSessionProbe = (url?: string): boolean =>
  Boolean(url?.includes('/api/auth/profile'));

export const shouldHardRedirectToLogin = (
  pathname: string,
  url?: string
): boolean => {
  if (isPublicAuthPath(pathname)) return false;
  if (isPublicApiPath(url)) return false;
  if (isAuthSessionProbe(url)) return false;
  return true;
};
